export default {"src":"/_next/static/media/invalid.ddc0c0c6.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};